import React from 'react';


//width="200" height="200" 
const Map = () => <div className='map'>


    <iframe width="425" height="350" src="https://www.openstreetmap.org/export/embed.html?bbox=-1.1656665022077428%2C51.2557110299259%2C-1.1184167082013952%2C51.27168899175814&amp;layer=mapnik&amp;marker=51.263700705149624%2C-1.142041605204554" ></iframe>
    <div className='open-larger'><a href="https://www.openstreetmap.org/?mlat=51.2636&amp;mlon=-1.1428#map=16/51.2636/-1.1428">View Larger Map</a></div>   
</div>;

export { Map }
